import type { SupportedCountry } from '@/constants/country';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { formatPostalCode } from '@/utils/currency/formatPostalCode';

import Input from '../Input';

export interface InputPostalCodeProps extends React.InputHTMLAttributes<HTMLInputElement> {
  countryCode?: SupportedCountry;
  value: string;
  onValueChange: (value: string) => void;
  error?: boolean;
}

export const InputPostalCode = ({
  countryCode,
  value,
  onValueChange,
  onBlur,
  error,
}: InputPostalCodeProps) => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'component.inputPostalCode',
  });

  const handleChange = (e: { target: { value: string } }) => {
    const { value } = e.target;
    const formatted = countryCode
      ? formatPostalCode(countryCode, value)
      : value;
    onValueChange(formatted);
  };

  return (
    <Input
      name="postalCode"
      autoComplete="postal-code"
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      error={error}
      placeholder={t('placeholder')}
    />
  );
};
